import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DefaultDoughnutChart from "examples/Charts/DoughnutCharts/DefaultDoughnutChart";

import { AuthContext } from "context";
import CrudService from "services/cruds-service";

import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import skill_delta_teaser_image from "assets/images/skill-delta-teaser.jpg";
import { CircularProgress, Icon } from "@mui/material";

const AssessTab = ({
  skillMatchScoreLoader,
  job,
  donutData,
  generateSkillMatchScore,
}) => {
  return (
    <>
      <MDTypography variant="h6">Assess Tab</MDTypography>
      <MDTypography variant="body2">Assess your fit for the job</MDTypography>
      <Grid item>
        <MDBox
          key="skill_match_score_block"
          display="block"
          bgColor="white"
          color="text"
          borderRadius="xl"
          mt={2.5}
          py={1.875}
          px={1.875}
          lineHeight={1.5}
          sx={{
            fontSize: ({ typography: { size } }) => size.md,
          }}
        >
          {skillMatchScoreLoader ? (
            <MDTypography variant="h6" fontWeight="medium" mt={1}>
              <CircularProgress color="info" size={15} /> &nbsp; Calculating
              Skill Match Score...
            </MDTypography>
          ) : (
            <>
              {job.skills_in_profile.length > 0 &&
              job.skills_in_job.length > 0 ? (
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={6}>
                    <DefaultDoughnutChart
                      title="Skill Match Score"
                      description={job.skill_match_score.toFixed(2) + "%"}
                      chart={donutData}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6}>
                    <MDTypography variant="h6" fontWeight="medium" mt={1}>
                      Skills in Job Description
                    </MDTypography>
                    <MDBox>
                      {job.skills_in_job.map((skill, index) => {
                        return (
                          <MDTypography key={index} variant="p1">
                            <Icon key={index} color="info">
                              radio_button_checked
                            </Icon>{" "}
                            &nbsp;
                            {skill} <br />
                          </MDTypography>
                        );
                      })}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <MDTypography variant="h6" fontWeight="medium" mt={1}>
                      Skills in Profile
                    </MDTypography>
                    <MDBox>
                      {job.skills_in_profile.map((skill, index) => {
                        return (
                          <MDTypography key={index} variant="p1">
                            <Icon key={index} color="success">
                              done
                            </Icon>
                            &nbsp;
                            {skill} <br />
                          </MDTypography>
                        );
                      })}
                    </MDBox>
                  </Grid>
                  {job.skill_delta.length > 0 ? (
                    <Grid item xs={12} sm={12} md={6}>
                      <MDTypography variant="h6" fontWeight="medium" mt={1}>
                        Skills to be learned
                      </MDTypography>
                      <MDBox>
                        {job.skill_delta.map((skill, index) => {
                          return (
                            <MDTypography key={index} variant="p1">
                              <Icon key={index} color="error">
                                remove
                              </Icon>
                              &nbsp;
                              {skill} <br />
                            </MDTypography>
                          );
                        })}
                      </MDBox>
                    </Grid>
                  ) : null}
                </Grid>
              ) : (
                <>
                  {/* Show teaser image and button to generate skill match score */}
                  <MDBox>
                    <img
                      src={skill_delta_teaser_image}
                      alt="skill-delta-teaser"
                    />
                  </MDBox>
                  <MDButton
                    variant="contained"
                    color="info"
                    onClick={generateSkillMatchScore}
                  >
                    Unveil Skill Match Score for 1 credit
                  </MDButton>
                </>
              )}
            </>
          )}
        </MDBox>
      </Grid>
    </>
  );
};

export default AssessTab;
